import { CHAT_FUNCTIONS } from '../../../config/chatFunctionNames';

/**
 * Check if a message is an update booking response.
 * Detection is purely by function_name — no text pattern matching.
 */
export function isUpdateBookingMessage(message) {
  return message?.function_name === CHAT_FUNCTIONS.UPDATE_BOOKING;
}

/**
 * Extract update booking data from a message.
 * Returns null when the message is not update_booking or has no bookings.
 *
 * @returns {{
 *   bookings: Array,
 *   updateHeader: string,
 *   selectionPrompt: string,
 *   conversationState: string,
 *   diffBlock: string
 * }|null}
 */
export function getUpdateBookingData(message) {
  if (!isUpdateBookingMessage(message)) return null;

  const bookings = message.raw_output?.bookings;
  if (!Array.isArray(bookings) || bookings.length === 0) return null;

  return {
    bookings,
    updateHeader: message.raw_output?.update_header || '',
    selectionPrompt: message.raw_output?.selection_prompt || '',
    conversationState: message.raw_output?.conversation_state || '',
    diffBlock: message.raw_output?.diff_block || '',
  };
}
